module.exports = __webpack_public_path__ + "img/untrackedNoticeSample.c25b371b.png";